import { client, fireStoreClient } from 'api/baseApi.ts';
import { captureDatadogErrors } from 'core/utils/datadogUtil';
import React, { createContext, useEffect, useState } from 'react';

const { collection, getDocs } = fireStoreClient;
const db = client.getFirebaseDb();
const DefaultValueContext = createContext({});

function FirebaseContext({ children }) {
	const [firebaseDefaultValues, setFirebaseDefaultValues] = useState({});

	useEffect(() => {
		async function getDefaultValues() {
			try {
				const querySnapshot = await getDocs(collection(db, 'defaultValues'));
				const defaultValues = {};
				querySnapshot.forEach((doc) => {
					defaultValues[doc.id] = doc.data();
				});
				setFirebaseDefaultValues(defaultValues);
			} catch (error) {
				captureDatadogErrors('Firebase default values not found', error);
			}
		}

		getDefaultValues();
	}, []);

	return (
		<DefaultValueContext.Provider value={firebaseDefaultValues}>
			{children}
		</DefaultValueContext.Provider>
	);
}

export { FirebaseContext, DefaultValueContext };
